import { usePathname } from 'expo-router'
import { startsWith } from 'lodash'
import { useMemo } from 'react'
import { useWindowDimensions, type StyleProp, type ViewStyle } from 'react-native'

import { DESKTOP_BREAKPOINT, MOBILE_BREAKPOINT, SIDEBAR_WIDTH } from '@/lib'

export const useBottomSheetContainerStyle = (containerStyle?: StyleProp<ViewStyle>) => {
  const pathname = usePathname()
  const { width } = useWindowDimensions()

  return useMemo(
    () => [
      containerStyle,
      !startsWith(pathname, '/onboarding') && width >= MOBILE_BREAKPOINT
        ? {
            marginLeft: width <= DESKTOP_BREAKPOINT ? SIDEBAR_WIDTH : (width - DESKTOP_BREAKPOINT) / 2 + SIDEBAR_WIDTH,
            maxWidth: DESKTOP_BREAKPOINT - SIDEBAR_WIDTH
          }
        : undefined
    ],
    [containerStyle, pathname, width]
  )
}
